import React from "react";
import { Outlet } from "react-router-dom";
import { Header } from "../SearchedTicket/Header";

// Shared shell for every authenticated screen that shows the app header.
//
// The header used to be rendered by each screen individually, so it unmounted
// and remounted on every route change — re-running its SignalR setup (an extra
// `GetOnlineUsers` round-trip per navigation), resetting its connection-status
// state machine, and re-registering the chat/notification listeners in
// useListenMessages. Mounting it once here keeps all of that stable across
// navigation; only the routed screen below it swaps out.
//
// The fragment is deliberate: screens previously rendered `<Header />` as a
// sibling of their own content inside App.js's flex column, and keeping the
// layout wrapper-free preserves that exact DOM shape.
//
// Screens that intentionally have no header (ChecklistAnalytics, which also
// renders as a tab inside ParentAnalytics) stay outside this route in App.js.
const AppLayout = () => (
  <>
    <Header />
    <Outlet />
  </>
);

export default AppLayout;
